import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { AppState } from 'src/app/state';
import { CalculatedVariable } from 'src/app/models/calculated-variable';
import {
  selectCalculatedVariables,
  selectIsLoadingCalculatedVariables,
  selectCalculatedVariablesLoaded,
} from 'src/app/dashboard/state/calculated-variable/calculated-variable.selectors';
import {
  deleteCalculatedVariable,
} from 'src/app/dashboard/state/calculated-variable/calculated-variable.actions';
import { openDashboardConfirmationDialog } from '../../../state/dashboard.actions';
import { CalculatedVariableDialogComponent } from '../../components/calculated-variable-dialog/calculated-variable-dialog.component';
import {Study} from "../../../../models/study";
import {selectSelectedStudy} from "../../../state/study/study.selectors";

@Component({
  selector: 'dashboard-calculated-variables',
  templateUrl: './calculated-variables.component.html',
  styleUrls: ['./calculated-variables.component.scss'],
})
export class CalculatedVariablesComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  selectedStudy$: Observable<Study>;
  selectedStudy: Study;

  loadingCalculatedVariables$: Observable<boolean>;
  isCalculatedVariablesLoaded$: Observable<boolean>;

  dataSource: MatTableDataSource<CalculatedVariable>;
  columnsToDisplay = ['name', 'description', 'formula', 'action'];

  constructor(private store: Store<AppState>, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.loadingCalculatedVariables$ = this.store.select(selectIsLoadingCalculatedVariables);
    this.isCalculatedVariablesLoaded$ = this.store.select(selectCalculatedVariablesLoaded);

    this.selectedStudy$ = this.store.select(selectSelectedStudy);
    this.subscriptions.add(this.selectedStudy$.subscribe((selectedStudy) => {
      if (selectedStudy) {
        this.selectedStudy = selectedStudy;
      }
    }));

    this.subscriptions.add(
      this.store.select(selectCalculatedVariables).subscribe((calculatedVariables) => {
        if (calculatedVariables) {
          this.dataSource = new MatTableDataSource(calculatedVariables);
        }
      })
    );
  }

  openCreateCalculatedVariableDialog() {
    this.dialog.open(CalculatedVariableDialogComponent, { width: '100%' });
  }

  openUpdateCalculatedVariableDialog(row: CalculatedVariable) {
    this.dialog.open(CalculatedVariableDialogComponent, {
      data: { calculatedVariable: row },
      width: '100%',
    });
  }

  openDeleteCalculatedVariableDialog(calculatedVariable: CalculatedVariable) {
    this.store.dispatch(
      openDashboardConfirmationDialog({
        dialogData: {
          title: `Are you sure you want to delete this calculated variable?`,
          onConfirm: deleteCalculatedVariable({ calculatedVariable }),
        },
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
